// extracted by mini-css-extract-plugin
export var copyableField = "_rt-4";
export var customerBadge = "_rt-0";
export var customerInfoTitle = "_rt-2";
export var details = "_rt-1";
export var dropdownContainer = "_rt-5";
export var dropdownImage = "_rt-6";
export var editAssigneeForm = "_rt-a";
export var editButton = "_rt-3";
export var email = "_rt-7";
export var hidden = "_rt-d";
export var input = "_rt-8";
export var saveButton = "_rt-b";
export var shopifyIcon = "_rt-c";
export var suggestionBadge = "_rt-e";
export var suggestionText = "_rt-f";
export var username = "_rt-9";